import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { ArrowLeft } from 'lucide-react';
import { useHistory, Link } from 'react-router-dom';
import { buttonClasses } from 'shared/components/Button';
import { useClientNames } from 'shared/hooks/useClientNames';
import EventoCreateWizard from '../components/EventoCreateWizard/EventoCreateWizard';
import useApplicantRoleService from '../services/useApplicantRoleService';
import useEventoService from '../services/useEventoService';

const EventoCreatePage = () => {
  const history = useHistory();
  const { clientesQuery } = useClientNames(false);
  const applicantRoleService = useApplicantRoleService();
  const rolesQuery = useSuperQuery(applicantRoleService.getRoles);
  const eventoService = useEventoService();

  const createMutation = useSuperMutation(eventoService.createEvent, {
    showSpinner: true,
    messages: { success: { message: 'El evento fue creado con éxito' } },
    onMutationFinish: (state) => {
      if (!state.isError && state.data) {
        history.push(`/main/inventories/events/${state.data.id}`);
      }
    }
  });

  return (
    <div className="min-h-screen bg-page-light dark:bg-page-dark">
      <PageHeader area="Inventarios" title="Crear Evento" />
      <PageContainer>
        <div className="flex w-full flex-col">
          <Link
            to="/main/inventories/events"
            className={buttonClasses('secondary', 'sm', 'mb-6 self-start')}
          >
            <ArrowLeft size={15} />
            Volver al listado
          </Link>
          <EventoCreateWizard
            clients={clientesQuery.data ?? []}
            roles={rolesQuery.data ?? []}
            isSubmitting={createMutation.isLoading}
            onSubmit={(payload) => createMutation.mutate(payload)}
          />
        </div>
      </PageContainer>
    </div>
  );
};

export default EventoCreatePage;
